import { observable } from 'mobx'

/**
 * Info about the application.
 */
export interface ShellInfo {
  /**
   * The name of the application.
   */
  readonly name: string

  /**
   * URL for the main icon.
   */
  readonly iconUrl: string

  /**
   * URL for the main icon, but for use on inverted (dark) surfaces.
   */
  readonly invertedIconUrl: string

  /**
   * URL for the main logo.
   */
  readonly logoUrl: string

  /**
   * URL for the main logo, but for use on inverted (dark) surfaces.
   */
  readonly invertedLogoUrl: string

  /**
   * URL for the system robot avatar.
   */
  readonly systemRobotAvatarUrl: string

  /**
   * Whether Taxfyle-specific info should be shown, such as support
   * blocks linking to the Taxfyle website.
   */
  readonly showTaxfyleInfo: boolean
}

/**
 * Creates a reactive {@link ShellInfo}.
 *
 * @param getter
 * @constructor
 */
export function ShellInfo(getter: () => ShellInfo) {
  return observable<ShellInfo>({
    get name() {
      return getter().name
    },
    get iconUrl() {
      return getter().iconUrl
    },
    get invertedIconUrl() {
      return getter().invertedIconUrl
    },
    get logoUrl() {
      return getter().logoUrl
    },
    get invertedLogoUrl() {
      return getter().invertedLogoUrl
    },
    get systemRobotAvatarUrl() {
      return getter().systemRobotAvatarUrl
    },
    get showTaxfyleInfo() {
      return getter().showTaxfyleInfo
    },
  })
}
